import React from "react";
const Tick = ({ height = "20", width = "20", ...props }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <g clipPath="url(#clip0_1_2175)">
          <path
            d="M9.99998 0.833313C8.18699 0.833313 6.41471 1.37093 4.90726 2.37817C3.39981 3.38542 2.22489 4.81706 1.53109 6.49205C0.837285 8.16704 0.655754 10.0101 1.00945 11.7883C1.36315 13.5665 2.23619 15.1998 3.51817 16.4818C4.80015 17.7638 6.4335 18.6368 8.21166 18.9905C9.98981 19.3442 11.8329 19.1627 13.5079 18.4689C15.1829 17.7751 16.6145 16.6002 17.6218 15.0927C18.629 13.5853 19.1666 11.813 19.1666 9.99998C19.1666 7.56883 18.2009 5.23725 16.4818 3.51817C14.7627 1.79908 12.4311 0.833313 9.99998 0.833313ZM8.69046 13.6601L5.41665 10.3863L6.45772 9.34522L8.69046 11.578L13.5422 6.72617L14.5872 7.76462L8.69046 13.6601Z"
            fill="#02C9A6"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_2175">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export default Tick;
